import React, { useEffect, useMemo, useState } from "react";
// import { StdButton } from "../StdButton";
import Async from "react-select/async";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { EMPTY_ARRAY, fetchProviderByKeyword, WaterProvider } from "../misc";

import { customStyles, GeoData, ProviderFinderProps, ProviderSearchResult } from "./types";
import { ProviderDropdownOption } from "./DropdownOption";

const getValues =
    (provider: WaterProvider) =>
    (text: string): Promise<ProviderSearchResult[]> => {
        return fetchProviderByKeyword(text).then(data => {
            return (
                data
                    ?.filter(d => d != null && d.adminId !== provider?.adminId)
                    ?.map(d => {
                        return {
                            name: d?.name,
                            provider: d
                        };
                    }) ?? (EMPTY_ARRAY as Array<{ name: string; provider: WaterProvider }>)
            );
        });
    };

export const ProviderFinder: React.FC<ProviderFinderProps> = ({ className, onChange, value, provider }) => {
    const [_value, _setValue] = useState<ProviderSearchResult>(value);

    useEffect(() => {
        _setValue(value);
    }, [value]);

    const _onChange = useMemo(() => {
        return (item: GeoData) => {
            _setValue(item);
        };
    }, []);

    return (
        <div className={`geo-encoder ${className ?? ""}`}>
            <Async
                isClearable
                cacheOptions
                components={{ Option: ProviderDropdownOption }}
                loadOptions={getValues(provider)}
                value={
                    _value && {
                        label: _value.name,
                        value: _value
                    }
                }
                onChange={onChange ?? _onChange}
                isLoading={false}
                defaultOptions={[]}
                placeholder={"Find a provider"}
                styles={customStyles}
                theme={theme => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: "#28336E"
                    }
                })}
            />

            <div className={"search-indicator"}>
                <FontAwesomeIcon icon={faSearch} />
            </div>
        </div>
    );
};
